import React, { useState, useEffect } from 'react';
import { InstagramVideoEmbedWrapper } from './components';
import { InstagramEmbed } from 'react-social-media-embed';

type InstagramVideoEmbedProps = {
  url: string;
};

const InstagramVideoEmbed = ({ url }: InstagramVideoEmbedProps) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    if (!isClient && typeof window !== 'undefined') {
      setIsClient(true);
    }
  }, []);
  return isClient ? (
    <InstagramVideoEmbedWrapper>
      <InstagramEmbed url={url} width={328} />
    </InstagramVideoEmbedWrapper>
  ) : null;
};

export default InstagramVideoEmbed;
